<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <!-- SEARCH -->
    <v-row class="no-gutters">
      <v-col cols="12">
        <v-text-field
          v-model="search"
          @input="debounceSearch"
          prepend-icon="mdi-magnify"
          label="Search here ..."
          single-line
          solo
          hide-details
        />
      </v-col>
    </v-row>

    <!-- TABLE -->
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="rounded-0 elevation-0"
          :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
        >
          <v-sheet
            class="transactionTable depositTabTable"
            :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'"
          >
            <v-data-table
              :headers="headers"
              :items="wallets"
              :server-items-length="pagination?.total || 0"
              :options.sync="options"
              :loading="isLoading"
              :items-per-page="options.itemsPerPage"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:',
              }"
              @update:options="handleOptionsChange"
              disable-sort
            >
              <!-- LOADING -->
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary" />
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>

              <!-- NO DATA -->
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>

              <!-- SL -->
              <template v-slot:item.sl="{ index }">
                {{ index + 1 }}
              </template>

              <!-- CLIENT NAME + ID -->
              <template v-slot:item.client="{ item }">
                <router-link
                  class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item.client_account_id}`"
                >
                  {{ item.name }} ({{ item.client_account_id }})
                </router-link>
              </template>

              <!-- TOTAL EARNING -->
              <template v-slot:item.manager_total_earning="{ item }">
                {{ Number(item.manager_total_earning || 0).toFixed(2) }} USD
              </template>

              <!-- TOTAL WITHDRAW -->
              <template v-slot:item.manager_total_withdraw="{ item }">
                {{ Number(item.manager_total_withdraw || 0).toFixed(2) }} USD
              </template>

              <!-- AVAILABLE BALANCE -->
              <template v-slot:item.manager_available_balance="{ item }">
                {{ Number(item.manager_available_balance || 0).toFixed(2) }} USD
              </template>

              <!-- ACTION -->
              <template v-slot:item.action="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" @click="openTransferModal(item)">
                      <v-icon small color="greenMain">mdi-bank-transfer</v-icon>
                    </v-btn>
                  </template>
                  <span>Wallet transfer</span>
                </v-tooltip>
              </template>

              <!-- CREATED AT -->
              <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at).toLocaleDateString() }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>

    <MamWalletTransferModal
      v-model="transferModal"
      :selected-wallet="selectedWallet"
      wallet-type="manager"
      :wallet-options="wallets"
      @success="handleTransferSuccess"
    />
  </v-card>
</template>

<script>
import { MAMWALLET__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import MamWalletTransferModal from "@/components/MamWallet/MamWalletTransferModal.vue";

export default {
  name: "ManagersWalletInfo",

  components: {
    MamWalletTransferModal,
  },

  data() {
    return {
      search: "",
      searchTimeout: null,
      transferModal: false,
      selectedWallet: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "SL", value: "sl" },
        { text: "Client", value: "client" },
        { text: "Email", value: "email" },
        { text: "Total Earning", value: "manager_total_earning" },
        { text: "Total Withdraw", value: "manager_total_withdraw" },
        { text: "Available Balance", value: "manager_available_balance" },
        { text: "Action", value: "action" },
        // { text: "Created At", value: "created_at" },
      ],
    };
  },

  computed: {
    ...mapState("managerswallet", {
      wallets: (state) => state.mamlists,
      pagination: (state) => state.pagination,
      isLoading: (state) => state.isLoading,
    }),
  },

  methods: {
    ...mapActions("managerswallet", [
      MAMWALLET__ACTIONS.MANAGERSWALLETINFO,
    ]),

    async fetchData() {
      const params = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      await this[MAMWALLET__ACTIONS.MANAGERSWALLETINFO](params);
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchData();
      }, 500);
    },

    handleOptionsChange(options) {
      this.options = options;
      this.fetchData();
    },

    openTransferModal(item) {
      this.selectedWallet = item;
      this.transferModal = true;
    },

    async handleTransferSuccess() {
      this.transferModal = false;
      this.selectedWallet = null;
      await this.fetchData();
    },
  },

  created() {
    this.fetchData();
  },
};
</script>
